const FAQ_ITEMS = [
  {
    q: 'Какой минимальный заказ?',
    a: 'Минимальный заказ — от 5 кг. Точные условия по категориям уточняйте у менеджера в Telegram.',
  },
  {
    q: 'Как происходит доставка?',
    a: 'Доставляем по всей России транспортными компаниями (СДЭК, Boxberry, Почта России) или курьером в крупных городах. Отправка в течение 3–5 рабочих дней после оплаты заказа. Способы и стоимость доставки обсуждаются при оформлении.',
  },
  {
    q: 'Какие способы оплаты?',
    a: 'Работаем только с юридическими лицами и ИП — оплата по счёту (безналичный расчёт). Для физических лиц заказ возможен через маркетплейсы: Ozon, Wildberries, Яндекс Маркет.',
  },
  {
    q: 'Есть ли скидки при больших объёмах?',
    a: 'Да, мы предоставляем дополнительные скидки при заказе от 15 000 рублей и выше. Также действуют специальные цены для постоянных клиентов. Подробности уточняйте у менеджера.',
  },
  {
    q: 'Какой срок годности у чая?',
    a: 'Срок годности зависит от вида чая: зелёный и белый — до 2 лет, улуны и чёрный — до 3 лет, пуэр — практически неограничен. Все товары поставляются свежими, с указанием даты производства. Хранить рекомендуется в сухом прохладном месте.',
  },
  {
    q: 'Можно ли вернуть товар?',
    a: 'Гарантируем возврат только при браке. Свяжитесь с менеджером в Telegram для решения вопроса.',
  },
];

export function FAQ() {
  return (
    <section id="faq" className="py-16 sm:py-24 px-4 bg-white">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-tea-900">
            Часто задаваемые вопросы
          </h2>
          <p className="mt-3 text-lg text-tea-600">
            Всё, что нужно знать о заказе и доставке
          </p>
        </div>
        <div className="mt-12 space-y-4">
          {FAQ_ITEMS.map((item, index) => (
            <details
              key={index}
              className="group p-5 rounded-xl bg-tea-50 border border-tea-100 hover:border-tea-200 transition-colors"
            >
              <summary className="font-semibold text-tea-900 cursor-pointer list-none flex items-center justify-between">
                <span>{item.q}</span>
                <svg className="w-5 h-5 text-tea-600 transform group-open:rotate-180 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </summary>
              <p className="mt-3 text-sm text-tea-600 leading-relaxed pl-0">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
